import WMICObjectUtil from './WMICObjectUtil';

const isVisible = (viewModel, path, defaultValue) =>
    WMICObjectUtil.getAtPath(viewModel, `${path}.aspects.ocular`, defaultValue);

const getMetaDataMapAvailableValues = (viewModel, path, mapper, defaultValue) => {
    const metaDataMap = viewModel?.metaDataMap?.value;
    const propMap = metaDataMap?.find(metadata => metadata?.propName === path);
    const availableValues = propMap?.availableValues;

    return (mapper ? availableValues?.map(mapper) : availableValues) ?? defaultValue;
};

const copyMetaDataMap = ({ dest, destPath = '', inclDestVal = true, src, srcPath = '', inclSrcVal = true }) => {
    WMICObjectUtil.setAtPath(
        dest,
        `${destPath}.metaDataMap${inclDestVal ? '.value' : ''}`,
        WMICObjectUtil.getAtPath(src, `${srcPath}.metaDataMap${inclSrcVal ? '.value' : ''}`)
    );

    return dest;
};

export default {
    isVisible,
    getMetaDataMapAvailableValues,
    copyMetaDataMap,
};
